import React from 'react';

const CheckmarkIcon = () => (
 <svg width="36" height="28" viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.7745 0.900854C32.7099 -0.0470194 34.2265 -0.0470194 35.1619 0.900854C36.0859 1.8371 36.0972 3.34793 35.1959 4.29828L16.0585 26.9205C16.0401 26.9438 16.0204 26.966 15.9996 26.9872C15.0641 27.935 13.5475 27.935 12.6121 26.9872L0.966345 15.1863C0.0309227 14.2385 0.0309227 12.7017 0.966344 11.7538C1.90177 10.8059 3.41838 10.8059 4.35381 11.7538L14.2337 21.7652L31.7109 0.97346C31.7307 0.947992 31.7519 0.923746 31.7745 0.900854Z" fill="#F9F9F9"/>
</svg>
);

export default CheckmarkIcon;